module.exports = __webpack_public_path__ + "static/media/favebiz-marketing@3x.500732ed.jpg";